import { fetchWithAuth } from '../../../common/utils/apiUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

class TerritorioCampesinoAgroalimentarioService {

    getMvtUrlTemplate() {
        return `${API_BASE_URL}/mvt/territorios-campesinos-agroalimentarios/{z}/{x}/{y}`;
    }

    async getAllTerritorioCampesinoAgroalimentariosGeoJson() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/territorios-campesinos-agroalimentarios/geojson`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return { data };
        } catch (error) {
            console.error('Error fetching territorios campesinos agroalimentarios GeoJSON:', error);
            throw error;
        }
    }
}

export default new TerritorioCampesinoAgroalimentarioService();
